import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import type { Placement } from "react-bootstrap/esm/types";
import type { OverlayInjectedProps } from "react-bootstrap/esm/Overlay";
import { FiAlertCircle } from "react-icons/fi";

import { copyTextToClipboard } from "utils/dom";

import "./InfoTooltip.scss";

interface InfoTooltipProps {
  tooltipBody?: React.ReactNode;
  placement?: string;
  iconSize?: number;
  copyText?: string;
  copyLabel?: string;
}

const InfoTooltip = ({
  tooltipBody,
  placement = "auto",
  iconSize = 14,
  copyText,
  copyLabel = "Text",
}: InfoTooltipProps) => {
  function renderTooltip(props: OverlayInjectedProps) {
    return (
      <Tooltip className="tooltip" {...props}>
        {tooltipBody}
      </Tooltip>
    );
  }

  const copyProps = copyText
    ? {
        role: "button",
        tabIndex: 0,
        "aria-label": `Copy ${copyLabel}`,
        onClick: () => copyTextToClipboard(copyText, copyLabel),
        onKeyDown: (e: React.KeyboardEvent) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            copyTextToClipboard(copyText, copyLabel);
          }
        },
      }
    : {};

  return (
    <OverlayTrigger
      // @ts-expect-error react-bootstrap's OverlayTrigger does not type a
      // className prop; preserved as-is from the original JS (runtime no-op).
      className="info-tooltip"
      placement={placement as Placement}
      delay={{ show: 250, hide: 200 }}
      overlay={renderTooltip}
      containerPadding={20}
      transition={true}
    >
      <span
        className={copyText ? "info-icon copyable" : "info-icon"}
        {...copyProps}
      >
        <FiAlertCircle
          size={iconSize}
          color={"#FFFFFF"}
          stroke={"#1D99A9"}
          strokeWidth={"1.5"}
        />
      </span>
    </OverlayTrigger>
  );
};

export default InfoTooltip;
